import { render, staticRenderFns } from "./DeviceEditTabHistory.vue?vue&type=template&id=07912cd8&"
import script from "./DeviceEditTabHistory.vue?vue&type=script&lang=js&"
export * from "./DeviceEditTabHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports